import React from "react";
import { connect } from "react-redux";
import * as agent from "../agent";
import { FormattedNumber } from "react-intl";
import Preloader from './Preloader';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class Main extends React.Component {
    state = {
        userLoansLoaded: false,
        userLoans: []
    }
    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        agent.User.getLoans(this.props.userId)
            .then(res => this.setState({ userLoans: res, userLoansLoaded: true }))
            .catch(err => alert(err.message));
    }

    render() {
        const { userLoans, userLoansLoaded } = this.state;
        const moneyTotal = userLoans.reduce((prev, next) => prev + next.cars.reduce((p,n) => p + ( ["ACTIVE","TRADE","CLOSED"].includes(n.loan.status) ? +n.contract.programDetails.sum : 0 ) ,0), 0);
        const moneyPending = moneyTotal * .02 ^ 0;
        const moneyEarned = 0;
        const loanCreated = userLoans.reduce((prev, next) => prev + next.cars.length, 0);
        const loanDenied = userLoans.reduce((prev, next) => prev + next.cars.filter(car => car.loan.status === "DENIED").length, 0);
        const loanApproved = userLoans.reduce((prev, next) => prev + next.cars.filter(car => ["ACTIVE","TRADE","CLOSED"].includes(car.loan.status) ).length, 0);

        return userLoansLoaded ?
                (<Fade in={userLoansLoaded}>
                    <Grid container justify="center" spacing={32} style={{ marginTop: 20, marginBottom: 20 }}>
                        <Grid item xs={4}>
                            <Paper className="padded-paper main-panel--blue">
                                <Typography variant="h5" gutterBottom>ВЫДАНО ЗАЙМОВ:</Typography>
                                <Typography variant="h5" gutterBottom>
                                    <FormattedNumber value={moneyTotal}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper className="padded-paper main-panel--blue">
                                <Typography variant="h5" gutterBottom>ВЫПЛАЧЕННАЯ СУММА:</Typography>
                                <Typography variant="h5" gutterBottom>
                                    <FormattedNumber value={moneyEarned}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper className="padded-paper main-panel--blue">
                                <Typography variant="h5" gutterBottom>ОЖИДАЕМЫЕ ПОСТУПЛЕНИЯ:</Typography>
                                <Typography variant="h5" gutterBottom>
                                    <FormattedNumber value={moneyPending}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper className="padded-paper main-panel--blue">
                                <Typography variant="h5" gutterBottom>ОТПРАВЛЕНО ВСЕГО:</Typography>
                                <Typography variant="h5" gutterBottom>{loanCreated}</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper className="padded-paper main-panel--blue">
                                <Typography variant="h5" gutterBottom>ДЕНЬГИ ВЫДАНЫ:</Typography>
                                <Typography variant="h5" gutterBottom>{loanApproved}</Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper className="padded-paper main-panel--red">
                                <Typography variant="h5" gutterBottom>ОТКАЗАНО:</Typography>
                                <Typography variant="h5" gutterBottom>{loanDenied}</Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                </Fade>) : <Preloader />
    }
}

const mapStateToProps = state => ({
    userId: state.common.user.id
});

export default connect(mapStateToProps, null)(Main);



// WEBPACK FOOTER //
// ./src/components/Main.js